import { render, staticRenderFns } from "./withdrawalApproval.vue?vue&type=template&id=5344d326&"
import script from "./withdrawalApproval.vue?vue&type=script&lang=js&"
export * from "./withdrawalApproval.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalApproval.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports